import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment-timezone";
import Select from "react-select";

class List extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      slots: []
    };
  }
  componentWillMount() {
    /*const events = this.generateWeek();
    this.setState({ events: events });*/
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {}

  onChange = (v, id) => {
    const color = v.color;
    this.props.updateSlot({
      variables: { id, color }
    });
  };

  generateRows = () => {
    let rows = [];
    this.props.slots.forEach(slot => {
      let row = (
        <tr
          key={slot.id}
          style={{
            backgroundColor: slot.color
          }}
        >
          <td style={{ width: "105px" }}>
            <Select
              placeholder="Couleur"
              onChange={v => this.onChange(v, slot.id)}
              clearable={false}
              labelKey="color"
              valueKey="color"
              options={this.props.colors}
              value={slot.color}
              valueComponent={ColorValue}
              optionComponent={ColorOption}
              style={{ width: "105px" }}
            />
          </td>
          <td>{moment(slot.startTime).format("HH:mm")}</td>
          <td>{slot.slotType.name}</td>
          <td>
            {slot.patient.nom} {slot.patient.prenom}
          </td>
          <td>{slot.comment}</td>
        </tr>
      );

      rows.push(row);
    });

    return rows;
  };

  render() {
    if (this.props.slots.length === 0) {
      return (
        <table className="table  margin-auto is-striped is-hoverable is-fullwidth">
          <tbody>
            <tr>
              <td colSpan="5">Pas de rendez-vous aujourd'hui!</td>
            </tr>
          </tbody>
        </table>
      );
    }
    return (
      <table
        id="waiting-room"
        className="table  margin-auto is-striped is-hoverable is-fullwidth"
      >
        <tbody>{this.generateRows()}</tbody>
      </table>
    );
  }
}

const UPDATE_SLOT = gql`
  mutation updateSlot($id: ID!, $color: String) {
    updateSlot(id: $id, color: $color) {
      id
    }
  }
`;

export default compose(
  graphql(UPDATE_SLOT, {
    name: "updateSlot"
  })
)(List);

const ColorOption = class ColorOption extends React.Component {
  propTypes: {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired
  };
  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };
  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };
  handleMouseMove = event => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };
  render() {
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
      >
        <span
          className="tag"
          style={{
            backgroundColor: this.props.option.color,
            width: "30px"
          }}
        />
      </div>
    );
  }
};
class ColorValue extends React.Component {
  propTypes: {
    children: PropTypes.node,
    placeholder: stringOrNode,
    value: PropTypes.object
  };
  render() {
    return (
      <div className="Select-value">
        <span
          className="tag"
          style={{
            backgroundColor: this.props.value.color,
            width: "30px",
            marginTop: "5px"
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/utilities/List.js